import { request } from "../utils";
import { apis } from "../constants";


export const getOrgs = (data: Partial<SearchOrgParams>) => {
    return request<PagedData<Orgnization>>(apis.searchOrgs, {
        method: 'post',
        data
    })
}

export const updateOrg = (orgnizationId: string, data: Partial<Orgnization>) => {
    return request(apis.updateOrg, {
        method: 'put', params: { orgnizationId }, data
    })
}

export const createOrg = (data: Partial<Orgnization>) => {
    return request(apis.createOrg, {
        method: 'post',
        data
    })
}

export const deleteOrg = (orgnizationId: string) => {
    return request(apis.deleteOrg, {
        method: 'delete', params: { orgnizationId }
    })
}